module.exports = __webpack_public_path__ + "img/res_result.ea0dd127.png";